import * as React from 'react';
import Button from '@mui/material/Button';
import DialogContentText from '@mui/material/DialogContentText';
import t from 'utils/translate';
import SimpleModal from './simple-modal';
import { Markup } from 'interweave';

function ConfirmationDialog({ title, closeCallback, question, yesText, noText, yesCallback, noCallback }) {
    const dialogTitle = typeof title !== 'undefined' ? title : t('js_all_confirmation');
    const yesButtonText = typeof yesText !== 'undefined' ? yesText : t('settings_call_forward_yes_button');
    const noButtonText = typeof noText !== 'undefined' ? noText : t('settings_call_forward_no_button');

    return (
        <SimpleModal
            className={`confirmation-dialog`}
            dialogTitle={dialogTitle}
            titleClassName={`confirmation-dialog-title`}
            closeCallback={closeCallback}
            buttons={
                <div className={'confirmation-dialog-actions'}>
                    <Button className="no-button" variant="contained" role="cancel" onClick={() => noCallback()}>
                        {noButtonText}
                    </Button>
                    <Button variant="contained" role="primary" onClick={() => yesCallback()}>
                        {yesButtonText}
                    </Button>
                </div>
            }
        >
            <DialogContentText>
                <Markup content={question} />
            </DialogContentText>
        </SimpleModal>
    );
}

export default ConfirmationDialog;
